import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

const STORED_IMAGE_URL = /https:\/\/api\..*\.?jumptech.co.uk\/store/;

const STORED_IMAGE_HEADERS = { skip: 'true', accept: 'image/png' };

const THUMBNAIL_SIZE = 's';

export function isStoredImageUrl(url: string): boolean {
  return STORED_IMAGE_URL.test(url);
}

function withThumbnailSize(url: string): string {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}size=${THUMBNAIL_SIZE}`;
}

@Injectable({ providedIn: 'root' })
export class StoredImageLoader {
  private readonly http = inject(HttpClient);

  public async displayUrlFor(url: string): Promise<string> {
    if (!isStoredImageUrl(url)) {
      return url;
    }

    const image = await firstValueFrom(this.http.get(url, { headers: STORED_IMAGE_HEADERS, responseType: 'blob' }));
    return URL.createObjectURL(image);
  }

  public async thumbnailUrlFor(url: string): Promise<string> {
    if (!isStoredImageUrl(url)) {
      return url;
    }

    return this.displayUrlFor(withThumbnailSize(url));
  }

  public release(displayUrl: string): void {
    if (displayUrl.startsWith('blob:')) {
      URL.revokeObjectURL(displayUrl);
    }
  }
}
